"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDescriptor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accessories",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "accessoryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_accessory",
                type: "bytes",
            },
        ],
        name: "addAccessory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_body",
                type: "bytes",
            },
        ],
        name: "addBody",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_color",
                type: "string",
            },
        ],
        name: "addColorToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_glasses",
                type: "bytes",
            },
        ],
        name: "addGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_head",
                type: "bytes",
            },
        ],
        name: "addHead",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_accessories",
                type: "bytes[]",
            },
        ],
        name: "addManyAccessories",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string[]",
                name: "newColors",
                type: "string[]",
            },
        ],
        name: "addManyColorsToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_glasses",
                type: "bytes[]",
            },
        ],
        name: "addManyGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_heads",
                type: "bytes[]",
            },
        ],
        name: "addManyHeads",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "bodies",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "glasses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "glassesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "heads",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$__906366b8c241906105629084906002906004016118fe565b5f60405180830381865af415801561057c573d5f803e3d5ffd5b505050506040513d5f823e601f3d908101601f191682016040526105a39190810190611929565b9392505050565b60605f60405180606001604052808681526020018581526020016105cd85610dfa565b9052604051635f8ef57160e11b815290915073__$e1d8844a0810dc0e87a665b1f2b5fa7c69$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class NounsDescriptor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, NounsDescriptor__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e1d8844a0810dc0e87a665b1f2b5fa7c69\\$__", "g"), linkLibraryAddresses["contracts/libs/NFTDescriptor.sol:NFTDescriptor"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDescriptor__factory = NounsDescriptor__factory;
NounsDescriptor__factory.bytecode = _bytecode;
NounsDescriptor__factory.abi = _abi;
